import { useCallback } from 'react';
import { useSetRecoilState } from 'recoil';

import { percomaticState } from '../../atoms';
import { modifyingState } from '../atoms';

import { clickDone } from '@biggby-coffee/percomatic-typescript/dist/src/api';
// import { addBreadcrumb } from '@sentry/react';

export const useClickDone = (): (() => ReturnType<typeof clickDone | any>) => {
	const setModifying = useSetRecoilState(modifyingState);
	const setPercomaticState = useSetRecoilState(percomaticState);

	return useCallback(
		async (...args) => {
			// console.debug(`making api call "clickDone (${args.join(', ')})"`);

			setModifying(true);

			// addBreadcrumb({
			// 	level: 'info',
			// 	category: 'percomatic',
			// 	message: 'clickDone',
			// 	data: {
			// 		args
			// 	}
			// });

			try {
				const [valid, state] = await clickDone(...args);

				setPercomaticState(state);
				setModifying(false);

				return [valid, state];
			} catch (err: any) {
				console.error(err);

				return err;
			}
		},
		[setModifying, setPercomaticState]
	);
};
